export enum TransactionOrigin
{
    Lake = 1,
    Manual = 2,
}

export enum TransactionType
{
    Invoice = 1,
    SupplierInvoice = 2,
}

export enum TransactionStatus
{
    Pending = 1,
    Discarded = 2
}

export type TransactionTypeCode = (typeof InboundTransactionTypeCode)[keyof typeof InboundTransactionTypeCode]['value'] | 
                                (typeof OutboundTransactionTypeCode)[keyof typeof OutboundTransactionTypeCode]['value'];

export type TransactionTypeCodeOption = {
  value: TransactionTypeCode;
  label: string;
}

export const InboundTransactionTypeCode = {
  CustomerPayments: {value: "INBOUND_CUSTOMER_PAYMENTS", label: "Kundbetalning"},
  NewLoan: {value: "INBOUND_NEW_LOAN", label: "Nya lån"},
  VatRefund: {value: "INBOUND_VAT_REFUND", label: "Moms att få tillbaka"},
  OtherPayments: {value: "INBOUND_OTHER_PAYMENTS", label: "Övriga inbetalningar"},
} as const;

export const OutboundTransactionTypeCode = {
  SupplierPayments: {value: "OUTBOUND_SUPPLIER_PAYMENTS", label: "Leverantörsutbetalningar"},
  LoanPayments: {value: "OUTBOUND_LOAN_PAYMENTS", label: "Räntor och amorteringar"},
  Salary: {value: "OUTBOUND_SALARY", label: "Lön"},
  SocialFees: {value: "OUTBOUND_SOCIAL_FEES", label: "Sociala avgifter"},
  PreliminaryTax: {value: "OUTBOUND_PRELIMINARY_TAX", label: "Prelskatt"},
  Expenses: {value: "OUTBOUND_EXPENSES", label: "Utlägg"},
  VatPayable: {value: "OUTBOUND_VAT_PAYABLE", label: "Moms att betala"},
  YearlyTax: {value: "OUTBOUND_YEARLY_TAX", label: "Årets skatt"},
  OtherExpenses: {value: "OUTBOUND_OTHER_EXPENSES", label: "Övriga utbetalningar"}
} as const;

export const TransactionTypeCodes = {
  ...InboundTransactionTypeCode,
  ...OutboundTransactionTypeCode
}

export interface LiquidityScenarioHead {
  id?: string;
  name?: string | null;
  dateFrom?: Date;
  dateTo?: Date;
}

export interface LiquidityScenarioTransaction {
    origin?: TransactionOrigin; // TODO Required?
    transactionType?: TransactionType; // TODO Required?
    transactionTypeCode?: string | null; // TODO Enum?
    transactionDate?: Date; // TODO Required?
    modifiedTransactionDate?: Date | null;
    key?: string | null;
    invoiceNumber?: string | null;
    externalInvoiceNumber?: string | null;
    otherPart?: string | null; // TODO Rename to description?
    amount?: number; // TODO Required?
    modifiedAmount?: number | null;
    status?: TransactionStatus;
}

export interface LiquidityScenario {
  id?: string;
  clientId?: string;
  connectionIds?: Array<string> | null;
  name?: string | null;
  dateFrom?: Date;
  dateTo?: Date;
  openingBalance?: number;
  transactions?: Array<LiquidityScenarioTransaction> | null;
}

export interface NewLiquidityScenario {
  clientId: string;
  connectionIds: Array<string> | null;
  name?: string | null;
  dateFrom: Date;
  dateTo: Date;
  openingBalance?: number;
  includedTransactionTypes: Array<TransactionType>;
}

export interface UpdateLiquidityScenarioHead {
  name: string | null;
  openingBalance: number;
}

export interface UpdateLiquidityScenario {
  transactions?: Array<LiquidityScenarioTransaction> | null;
}

